import React from 'react';
import '../styles.css';
import '../popup.css';
import '../try.css';
import '../App.css';

export default function Footer() {



    return (
        <div className="footer-parent">
            <footer className="footer">
                <div className="footer-flex">
                    {/* <div className="footer-header">Connect with me on</div> */}

                    <ul className="links social-links list-non-bullets">
                        <li className="list-item-inline icon-social"><a className="link" href="https://github.com/ZuberDunge"><i
                            className="fab fa-github social"></i></a></li>
                        <li className="list-item-inline icon-social"><a className="link" href="https://www.instagram.com/zuberdunge/"><i
                            className="fab fa-instagram social"></i></a></li>
                        <li className="list-item-inline icon-social"><a className="link" href="https://www.linkedin.com/in/zuberdunge/"><i
                            className="fab fa-linkedin-in social"></i></a></li>
                        <li className="list-item-inline icon-social"><a className="link" href="https://www.twitter.com/zuberdunge/"><i
                            className="fab fa-twitter social"></i></a></li>
                        <li className="list-item-inline icon-social"><a className="link" href="mailto:iamZuberDunge@gmail.com"><i
                            className="fas fa-envelope social"></i></a></li>
                    </ul></div>

                <p>Made with ReactJS  💕  </p>
                <p>© Zuber Dunge, 2021 All rights reserved. </p>
            </footer></div>
    );
}






